import { observer } from 'mobx-react'
import { Dropdown, DropdownTitle } from '../../../components/Dropdown'
import Tooltip from '../../../components/Tooltip'
import Button from '../../../components/Button'
import Icon from '../../../components/Icon'
import React from 'react'

export default observer(() => (
  <Dropdown
    autoDismiss
    position="bottom-end"
    button={
      <Tooltip content="Actions" placement="bottom">
        <Button
          size="baseline"
          type="text"
          dataTest="user-management-table-menu-toggle"
        >
          <Icon color="var(--grey600)" name="more" />
        </Button>
      </Tooltip>
    }
  >
    <DropdownTitle>Actions</DropdownTitle>
  </Dropdown>
))
